import { cn } from "~/ui-rtk/utils/tailwind-utils"
import { MetricCardConfig } from "../../../types"
import ScrollableMetricCard from "../ScrollableMetricCard"

type MetricsCardsGridProps = {
  cards: MetricCardConfig[]
  isLoading?: boolean
  className?: string
}

export default function MetricsCardsGrid({
  cards,
  isLoading = false,
  className,
}: MetricsCardsGridProps) {
  return (
    <div
      className={cn(
        "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4",
        className,
      )}
    >
      {cards.map(card => (
        <ScrollableMetricCard
          key={card.id}
          title={card.title}
          metrics={card.metrics}
          isLoading={isLoading}
        />
      ))}
    </div>
  )
}
